@let vm = viewModel$ | async;
@let fromADP = (queryParams$ | async).fromADP;
@if (vm) {
	@if (vm.hasError) {
		<bp-try-again-error
			[title]="'order_cancel_error_subtitle' | translate"
			(onRetry)="resetViewModel()"></bp-try-again-error>
	} @else {
		<div class="consent-screen-container">
			<svg-inline class="warning-icon" src="/assets/images/staking/earn-consent-warning-icon.svg" alt="image-icon" />
			<h1> {{ "earn_consent_screen_title" | translate }}</h1>
			@for (term of vm.terms; track term) {
				<!-- consent.component.html -->
				<div class="terms">
					<div class="terms-text">
						{{ term.text }}
					</div>
				</div>
			}
			<div class="cta-container">
				<button class="btn btn-primary btn-mod" (click)="acceptTerms(vm.terms)">
					{{ "earn_consent_screen_primary_cta" | translate }}</button
				>
				<button class="btn secondary-cta" (click)="cancel(fromADP)"> {{ "cancel" | translate }}</button>
			</div>
		</div>
	}
} @else {
	<loading-spinner></loading-spinner>
}
